import { defineComponent as m, openBlock as o, createElementBlock as e, mergeProps as p, unref as n, renderSlot as Z, createElementVNode as l, createCommentVNode as i } from "vue";
import { useScalarIcon as u } from "../hooks/useScalarIcon.js";
const g = { key: 0 }, M = { key: 1 }, f = { key: 2 }, h = { key: 3 }, k = { key: 4 }, w = { key: 5 }, y = {
  name: "ScalarIconDotsThree"
}, H = /* @__PURE__ */ m({
  ...y,
  props: {
    label: {},
    weight: {}
  },
  setup(r) {
    const s = r, { bind: d, weight: a } = u(s);
    return (A, t) => (o(), e("svg", p({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      fill: "currentColor"
    }, n(d)), [
      Z(A.$slots, "default"),
      n(a) === "bold" ? (o(), e("g", g, t[0] || (t[0] = [
        l("path", { d: "M144,128a16,16,0,1,1-16-16A16,16,0,0,1,144,128ZM60,112a16,16,0,1,0,16,16A16,16,0,0,0,60,112Zm136,0a16,16,0,1,0,16,16A16,16,0,0,0,196,112Z" }, null, -1)
      ]))) : n(a) === "duotone" ? (o(), e("g", M, t[1] || (t[1] = [
        l("path", {
          d: "M240,96v64a16,16,0,0,1-16,16H32a16,16,0,0,1-16-16V96A16,16,0,0,1,32,80H224A16,16,0,0,1,240,96Z",
          opacity: "0.2"
        }, null, -1),
        l("path", { d: "M140,128a12,12,0,1,1-12-12A12,12,0,0,1,140,128Zm56-12a12,12,0,1,0,12,12A12,12,0,0,0,196,116ZM60,116a12,12,0,1,0,12,12A12,12,0,0,0,60,116Z" }, null, -1)
      ]))) : n(a) === "fill" ? (o(), e("g", f, t[2] || (t[2] = [
        l("path", { d: "M224,80H32A16,16,0,0,0,16,96v64a16,16,0,0,0,16,16H224a16,16,0,0,0,16-16V96A16,16,0,0,0,224,80ZM60,140a12,12,0,1,1,12-12A12,12,0,0,1,60,140Zm68,0a12,12,0,1,1,12-12A12,12,0,0,1,128,140Zm68,0a12,12,0,1,1,12-12A12,12,0,0,1,196,140Z" }, null, -1)
      ]))) : n(a) === "light" ? (o(), e("g", h, t[3] || (t[3] = [
        l("path", { d: "M138,128a10,10,0,1,1-10-10A10,10,0,0,1,138,128ZM60,118a10,10,0,1,0,10,10A10,10,0,0,0,60,118Zm136,0a10,10,0,1,0,10,10A10,10,0,0,0,196,118Z" }, null, -1)
      ]))) : n(a) === "regular" ? (o(), e("g", k, t[4] || (t[4] = [
        l("path", { d: "M140,128a12,12,0,1,1-12-12A12,12,0,0,1,140,128Zm56-12a12,12,0,1,0,12,12A12,12,0,0,0,196,116ZM60,116a12,12,0,1,0,12,12A12,12,0,0,0,60,116Z" }, null, -1)
      ]))) : n(a) === "thin" ? (o(), e("g", w, t[5] || (t[5] = [
        l("path", { d: "M136,128a8,8,0,1,1-8-8A8,8,0,0,1,136,128Zm-76-8a8,8,0,1,0,8,8A8,8,0,0,0,60,120Zm136,0a8,8,0,1,0,8,8A8,8,0,0,0,196,120Z" }, null, -1)
      ]))) : i("", !0)
    ], 16));
  }
});
export {
  H as default
};
